module.exports = __webpack_public_path__ + "static/img/red-envelop-quit.d8187ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/red-envelop-quit.png
// module id = bMlb
// module chunks = 215